module.exports = __webpack_public_path__ + "static/media/25.aa6de1bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/25.svg
// module id = 142
// module chunks = 0